import React from 'react'
import HeaderImage from "../../assets/header.png"

const Header = () => {
  return (
    <div>
      <a href="https://www.credomgt.com/" target="blank">
        <img
          style={{
            width: "100%",
            height: "auto",
            alignSelf: "center",
            objectFit: "fill",
          }}
          src={HeaderImage}
          alt="Uganda Property Tax Calculator Header"
        />
      </a>
    </div>
  )
}

export default Header